import React, { createContext, useContext, useState } from 'react';

const ExpiryContext = createContext();

export const useExpiry = () => {
  const context = useContext(ExpiryContext);
  if (!context) {
    throw new Error('useExpiry must be used within an ExpiryProvider');
  }
  return context;
};

export const ExpiryProvider = ({ children }) => {
  const [isExpired, setIsExpired] = useState(false);
  const [expiryMessage, setExpiryMessage] = useState('');

  const triggerExpiry = (message = 'Your subscription has expired. Please renew to continue.') => {
    setExpiryMessage(message);
    setIsExpired(true);
  };

  const clearExpiry = () => {
    setIsExpired(false);
    setExpiryMessage('');
  };

  const value = {
    isExpired,
    expiryMessage,
    triggerExpiry,
    clearExpiry
  };

  return (
    <ExpiryContext.Provider value={value}>
      {children}
    </ExpiryContext.Provider>
  );
};